function activateDatePicker() {
  $("#desktop-date").datepicker({
    format: "yyyy-mm-dd",
    startDate: "+4d",
    endDate: "+30d",
    language: "ja",
    todayHighlight: true,
    clearBtn: true,
  }).on('changeDate', function(e){
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          "shipandco-配達希望日": $("#desktop-date").val()
        }
      })
    })
    $("#drawer-date").val($("#desktop-date").val());
    $("#mobile-date").val($("#drawer-date").val());
  });
  $("#desktop-date").datepicker("update", $("#desktop-date").data("delivery_date"));
}

function activateDrawerDatePicker() {
  $("#drawer-date").datepicker({
    format: "yyyy-mm-dd",
    startDate: "+4d",
    endDate: "+30d",
    language: "ja",
    todayHighlight: true,
    clearBtn: true,
  }).on('changeDate', function(e){
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          "shipandco-配達希望日": $("#drawer-date").val()
        }
      })
    })
    $("#desktop-date").val($("#drawer-date").val());
    $("#mobile-date").val($("#drawer-date").val());
  });
  $("#drawer-date").datepicker("update", $("#drawer-date").data("delivery_date"));
}

function activateMobileDatePicker() {
  $("#mobile-date").datepicker({
    format: "yyyy-mm-dd",
    startDate: "+4d",
    endDate: "+30d",
    language: "ja",
    todayHighlight: true,
    clearBtn: true,
  }).on('changeDate', function(e){
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          "shipandco-配達希望日": $("#mobile-date").val()
        }
      })
    })
    $("#desktop-date").val($("#mobile-date").val());
    $("#drawer-date").val($("#mobile-date").val());
  });
  $("#mobile-date").datepicker("update", $("#mobile-date").data("delivery_date"));
}

$(document).ready(function() {
  activateDatePicker();
  activateDrawerDatePicker();
  activateMobileDatePicker();
});